import { review } from '@/common/service/ApiList';
import { updateToast, insertToast, removeToast } from '@/common/utils/ToastServiceResult';
import { assist } from '@/common/utils/ParameterAssistant';

import ServiceExec from '@/common/utils/ServiceExec';

const { getList, saveRepl} = review;

const actions = {
  FETCH_LIST: async ({ commit, state }, page) => {
    const { condition } = state;
    commit('setCondition', assist(condition, page));

    const { status, data } = await ServiceExec.get(getList, condition);
    if (status === 200) {
      const { list, pageInfo } = data;
      commit('setList', list ?? []);
      commit('setPageInfo', pageInfo ?? {});
    }
  },
  SAVE: async ({commit, state}, form ) => {
    const {status, data} = await ServiceExec.post(saveRepl, form)
    if(updateToast(status, data)) return true
    else return false
  }
};
export default actions;

